// composables/aspirantes/useAspirantesActions.js

import { ref, reactive } from '@vue/composition-api'
import store from '@/store'

export default function useAportacionesActions() {
  const errorMessage = ref(null)
  const mensajeTask = ref(null)
  const loading = ref(false)

  const resetMessage = () => {
    errorMessage.value = null
    mensajeTask.value = null
  }

  const datosReject = reactive({
    action: 18,
    id: null,
    task: 'wscompras',
  })

  const datosCorreo = reactive({
    task: 'wscorreos',
    action: 2,
    transaccion: null,
    orden: null,
  })

  const datosCorreoFactura = reactive({
    task: 'wscorreos',
    action: 6,
    transaccion: null,
  })

  const datosLevel5 = ref({
    action: 49,
    registro: null,
  })

  const buildPayload = () => {
    const payload = { ...datosReject }
    return payload
  }

  const buildPayloadMail = () => {
    const payload = { ...datosCorreo }
    return payload
  }

  const buildPayloadMailFactura = () => {
    const payload = { ...datosCorreoFactura }
    return payload
  }

  const cancelar = async id => {
    if (!id) return
    resetMessage() // clean warnings
    loading.value = true
    try {
      datosReject.id = id
      const resp = await store.dispatch('compras/postCompras', buildPayload())
      mensajeTask.value = resp.message || 'Aspirante rechazado exitosamente.'
    } catch (err) {
      errorMessage.value = 'Error al guardar el comprobante. Por favor, intenta de nuevo.'
      throw err
    } finally {
      loading.value = false
    }
  }

  const reenviarCorreo = async (transaccionId, idOrden, aditionalMails = null) => {
  // Debe existir al menos registroId o idOrden
    if (!transaccionId && !idOrden) return
    resetMessage() // clean warnings
    loading.value = true
    try {
      datosCorreo.orden = parseInt(idOrden, 10)
      datosCorreo.transaccion = parseInt(transaccionId, 10)
      datosCorreo.isCC = aditionalMails
      const resp = await store.dispatch(
        'compras/postCompras',
        buildPayloadMail(),
      )
      const { status } = resp

      if (status !== 200) throw new Error(resp.message)

      mensajeTask.value = resp.message || resp.process?.notificacion || 'Correo reenviado exitosamente.'
    } catch (err) {
      errorMessage.value = err.message || 'Error al reenviar el correo. Por favor, intenta de nuevo.'
      throw err
    } finally {
      loading.value = false
    }
  }

  const reenviarFactura = async (transaccionId, idOrden, aditionalMails = null) => {
  // Debe existir al menos registroId o idOrden
    if (!transaccionId && !idOrden) return
    resetMessage() // clean warnings
    loading.value = true
    try {
      datosCorreo.orden = parseInt(idOrden, 10)
      datosCorreo.transaccion = parseInt(transaccionId, 10)
      datosCorreo.isCC = aditionalMails
      datosCorreo.action = 7
      const resp = await store.dispatch(
        'compras/postCompras',
        buildPayloadMail(),
      )
      const { status } = resp

      if (status !== 200) throw new Error(resp.message)

      mensajeTask.value = resp.message || resp.process?.notificacion || 'Correo reenviado exitosamente.'
    } catch (err) {
      errorMessage.value = err.message || 'Error al reenviar el correo. Por favor, intenta de nuevo.'
      throw err
    } finally {
      loading.value = false
    }
  }

  const resendinvitacionFacturar = async (transaccionId, aditionalMails = null) => {
  // Debe existir al menos registroId
    if (!transaccionId) return
    resetMessage() // clean warnings
    loading.value = true
    try {
      datosCorreoFactura.transaccion = transaccionId
      datosCorreoFactura.isCC = aditionalMails

      const resp = await store.dispatch(
        'compras/postCompras',
        buildPayloadMailFactura(),
      )
      const { status } = resp

      if (status !== 200) throw new Error(resp.message)

      mensajeTask.value = resp.message || resp.process?.notificacion || 'Correo reenviado exitosamente.'
    } catch (err) {
      errorMessage.value = err.message || 'Error al reenviar el correo. Por favor, intenta de nuevo.'
      throw err
    } finally {
      loading.value = false
    }
  }

  const upgradeNivel5 = async registroId => {
    if (!registroId) return
    loading.value = true
    resetMessage() // clean warnings
    datosLevel5.registro = registroId

    try {
      const response = await store.dispatch('compras/postCompras', datosLevel5)

      if (response.status !== 200) throw new Error(response.message)
      mensajeTask.value = response.message || 'Nivel actualizado exitosamente.'
    } catch (err) {
      errorMessage.value = err.message || 'Error al actualizar el nivel. Por favor, intenta de nuevo.'
      throw err
    } finally {
      loading.value = false
    }
  }

  return {
    loading,
    errorMessage,
    mensajeTask,
    // actions
    cancelar,
    reenviarCorreo,
    reenviarFactura,
    resendinvitacionFacturar,
    upgradeNivel5,

  }
}
